export function isModifiedClick(event) {
  return event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0
}

export function internalPathFromAnchor(anchor) {
  if (!anchor || anchor.target && anchor.target !== '' && anchor.target !== '_self') {
    return null
  }
  if (anchor.hasAttribute('download')) return null
  const href = anchor.getAttribute('href')
  if (!href || href.startsWith('mailto:') || href.startsWith('tel:') || href.startsWith('javascript:')) {
    return null
  }
  if (href.startsWith('#')) return null
  let url
  try {
    url = new URL(href, window.location.origin)
  } catch {
    return null
  }
  if (url.origin !== window.location.origin) return null
  return `${url.pathname}${url.search}${url.hash}`
}

export function attachSpaLinkInterceptor(navigate) {
  const onClick = (event) => {
    if (event.defaultPrevented || isModifiedClick(event)) return
    const anchor = event.target.closest?.('a')
    if (!anchor || !event.currentTarget.contains(anchor)) return
    const path = internalPathFromAnchor(anchor)
    if (!path) return
    event.preventDefault()
    if (`${window.location.pathname}${window.location.search}${window.location.hash}` === path) {
      return
    }
    navigate(path)
  }
  document.addEventListener('click', onClick)
  return () => document.removeEventListener('click', onClick)
}
